import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Icons } from '@vex/icons/icons';

@Component({
  selector: 'vex-tooltip-read-more',
  templateUrl: './tooltip-read-more.component.html',
  styleUrls: ['./tooltip-read-more.component.scss']
})
export class TooltipReadMoreComponent extends Icons implements OnInit {

  content: any;
  heading: any;

  constructor(public dialogRef: MatDialogRef<TooltipReadMoreComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    super();
    this.content = data.Text;
    this.heading = data.Heading;
  }

  ngOnInit(): void {
  }

  isHtmlContent(content: string): boolean {
  return /<\/?[a-z][\s\S]*>/i.test(content);
}

  getHeight(height: number = 0) {
    const height_inner = (window.innerHeight - height).toString();
    return height_inner + 'px';
  }

  onClose(dialogRef) {
    dialogRef.close();
  }

}
